export default function BusinessMap() {
  const processes = [
    { icon: 'ri-search-line', label: '商品リサーチ' },
    { icon: 'ri-calculator-line', label: '利益計算' },
    { icon: 'ri-file-list-line', label: '出品（カタログ）' },
    { icon: 'ri-price-tag-line', label: '価格調整' },
    { icon: 'ri-inbox-line', label: '在庫管理' },
    { icon: 'ri-truck-line', label: '発送' },
    { icon: 'ri-megaphone-line', label: '広告運用' },
    { icon: 'ri-bar-chart-line', label: '利益分析' }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-black text-gray-900 mb-6">
            Amazon業務 <strong className="text-primary">全体マップ</strong>
          </h2>
          <p className="text-xl text-gray-600">
            まず業務を分解するとこうなります：
          </p>
        </div>
        
        <div className="relative max-w-5xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {processes.map((process, index) => (
              <div key={index} className="relative">
                <div className="bg-white border-2 border-primary/20 rounded-xl p-6 hover:border-primary hover:shadow-lg transition-all">
                  <div className="flex flex-col items-center text-center space-y-4">
                    <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center">
                      <i className={`${process.icon} text-3xl text-primary`}></i>
                    </div>
                    <div className="font-bold text-gray-900">{process.label}</div>
                  </div>
                </div>
                
                {index < processes.length - 1 && (
                  <div className="hidden lg:block absolute top-1/2 -right-3 transform -translate-y-1/2 z-10">
                    <i className="ri-arrow-right-line text-2xl text-primary"></i>
                  </div>
                )}
              </div>
            ))}
          </div>
          
          <div className="mt-12 text-center">
            <div className="inline-block bg-primary/10 border-2 border-primary rounded-xl px-8 py-4">
              <p className="text-xl font-bold text-primary">
                これを1つずつ自動化。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
